import { BOOKING_CONTRACT_VALUES } from './booking.contract-values';

/** Core's published defaults, limits and links; the only place the UI reads them from. */
export const BOOKING_LIMITS = BOOKING_CONTRACT_VALUES.limits;

/** Page-size ceiling for slot and booking lists. */
export const SLOT_PAGE_LIMIT = BOOKING_LIMITS.pageLimit.max;

/** Path prefix of the reminder page; the reminder uuid follows. */
export const BOOKING_REMINDER_PAGE_PATH = BOOKING_CONTRACT_VALUES.links.reminderPagePath;
